module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"post":"投稿","total":"総数","edit_profile":"プロフィール編集","favorited_post":"いいねした投稿","commented_post":"コメントした投稿"}}')
  delete Component.options._Ctor
}
